export default __webpack_public_path__ + "static/media/angsana-teluk-bahang-slider.01cde8e4.jpg";